import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageContent, useSiteSettings } from '../../../hooks/useContentful';
import { ContentfulText, ContentfulMultilineText } from '../../Contentful';
import { HandDrawnButton } from '../../shared/HandDrawnButton/HandDrawnButton';
import { createSelfbookHandler } from '../../../utils/selfbook';
import './FilmCTA.css';

interface FilmCTAProps {
  heading?: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

const FilmCTA: React.FC<FilmCTAProps> = ({ 
  heading,
  buttonText,
  onButtonClick
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data: pageContentData } = usePageContent('film-collection');
  const { data: siteSettingsData } = useSiteSettings();
  const pageContent = pageContentData?.[0]?.fields as any;
  const siteSettings = siteSettingsData?.[0]?.fields as any;
  const handleBooking = createSelfbookHandler(navigate);
  return (
    <div className="film-cta-section" data-scroll-section="cta">
      <div className="film-cta-content">
        <h2>
          <ContentfulMultilineText 
            content={heading || pageContent?.ctaTitle} 
            fallback={t('pages/filmCollection:cta.text')}
          />
        </h2>
        <HandDrawnButton
          text={buttonText || pageContent?.ctaButtonText || siteSettings?.globalCTAs?.getInTouch || t('pages/filmCollection:cta.button')}
          onClick={onButtonClick || handleBooking}
          variant="brand"
          color="awasi"
          animation="stroke-to-fill"
          size="normal"
        />
      </div>
    </div>
  );
};

export default FilmCTA;